import { useEffect } from "react";
import { useMeMutation } from "../service/userApi";

export const useUserData = () => {
  const [me, { data, error, isLoading }] = useMeMutation();

  useEffect(() => {
    me("");
  }, [me]);

  return {
    user: data?.data,
    isLoading,
    error,
  };
};
